import type { GetStaticPropsResult } from './_hook'
import { WorkView } from './_view'

export const Work = (props: GetStaticPropsResult) => {
  return <WorkView {...props} />
}
